import { NgModule } from '@angular/core';
// import { SlideshowModule } from 'ng-simple-slideshow';
import { NgImageSliderModule } from 'ng-image-slider';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPayPalModule } from 'ngx-paypal';

@NgModule({
  imports: [],
  declarations: [],
  exports: [

    // SlidShow (ne fonctionne pas bien sur angular 9 pour le moment)
    // SlideshowModule,

    // Remplace temporairement le slideshow d'au dessus
    NgImageSliderModule,

    // Nouveau slideshow... (test)
    CarouselModule,

    //Paypal
    NgxPayPalModule

  ]

})

export class LibsModule { }
